<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      class="mx-0"
    >
      <v-col
        cols="12"
      >
        <material-card
          :key="updateKey"
          color="secondary"
          no-padding
          :loading="loading"
        >
          <template v-slot:header>
            <v-row
              class="px-4"
            >
              <v-col
                cols="12"
                sm="5"
              >
                {{ $route.name }} data from {{ moment(dates.start).format('LL') }} to <br> {{ moment(dates.end).format('LL') }}
              </v-col>

              <v-col
                cols="12"
                sm="7"
                style="display: flex; align-items: center;"
              >
                <v-text-field
                  v-model="dates.start"
                  hide-details
                  label="From"
                  prepend-icon="mdi-calendar"
                  readonly
                  @click="() => {
                    picker = true
                    currentPicker = 'start'
                  }"
                />
                <v-text-field
                  v-model="dates.end"
                  hide-details
                  label="To"
                  prepend-icon="mdi-calendar"
                  readonly
                  @click="() => {
                    picker = true
                    currentPicker = 'end'
                  }"
                />

                <v-btn
                  icon
                  :disabled="loading"
                  @click="updateKey++"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <traffic
            v-bind="$attrs"
            :dates="dates"
            :toggle-loading="() => loading = !loading"
          />
        </material-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="picker"
      persistent
      width="290px"
    >
      <v-date-picker
        v-model="dates[currentPicker]"
        scrollable
      >
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="picker = false"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import Traffic from './db/Traffic.vue'
  export default {
    components: {
      Traffic
    },
    data: () => ({
      updateKey: 0,
      loading: false,
      picker: false,
      currentPicker: null,
      dates: {
        start: moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD'),
        end: moment().startOf('day').format('YYYY-MM-DD')
      },
    }),
    methods: {
      moment
    }

  }
</script>
